<template>
  <div v-if="users[1] && users[0] && users[2]" class="podium">
    <div class="second" @click="show(users[1].id)">
      <div class="second-header">
        <v-avatar class="mt-2" size="58">
          <img
            :alt="users[1].user_name"
            :src="users[1].avatar || 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'"
          />
        </v-avatar>
        <span class="mt-2 text">
          <a
            v-if="getName(users[1]) !== ''"
            :title="getUserName(users[1])"
            class="sr-mention"
            v-html="getName(users[1])"
          ></a>
          <a
            v-if="getName(users[1]) === '' && getUserName(users[1]) !== ''"
            class="sr-mention"
            v-text="'@' + getUserName(users[1])"
          ></a>
          <a
            v-if="getName(users[1]) === '' && getUserName(users[1]) === ''"
            class="sr-mention"
            v-text="'@' + getOrigin(users[1])"
          ></a>
        </span>
      </div>
      <div class="second-content" style="text-align: center">
        <br />
        <span class="font-weight-medium">
          {{ $t("dashboard.ranking.created") }} {{ users[1].created_at | moment("from", true) }}
        </span>
        <br />
        <span class="font-weight-medium">
          {{ users[1].publication_counter }} {{ $t("dashboard.ranking.publications") }}
        </span>
      </div>
    </div>
    <div class="first" @click="show(users[0].id)">
      <div class="first-header">
        <v-avatar class="mt-2" size="58">
          <img
            :alt="users[0].user_name"
            :src="users[0].avatar || 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'"
          />
        </v-avatar>
        <span class="mt-2 text">
          <a
            v-if="getName(users[0]) !== ''"
            :title="getUserName(users[0])"
            class="sr-mention"
            v-html="getName(users[0])"
          ></a>
          <a
            v-if="getName(users[0]) === '' && getUserName(users[0]) !== ''"
            class="sr-mention"
            v-text="'@' + getUserName(users[0])"
          ></a>
          <a
            v-if="getName(users[0]) === '' && getUserName(users[0]) === ''"
            class="sr-mention"
            v-text="'@' + getOrigin(users[0])"
          ></a>
        </span>
      </div>
      <div class="first-content" style="text-align: center">
        <br />
        <span class="font-weight-medium">
          {{ $t("dashboard.ranking.created") }} {{ users[0].created_at | moment("from", true) }}
        </span>
        <br />
        <span class="font-weight-medium">
          {{ users[0].publication_counter }} {{ $t("dashboard.ranking.publications") }}
        </span>
      </div>
    </div>
    <div class="third" @click="show(users[2].id)">
      <div class="third-header">
        <v-avatar class="mt-2" size="58">
          <img
            :alt="users[2].user_name"
            :src="users[2].avatar || 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'"
          />
        </v-avatar>
        <span class="mt-2 text">
          <a
            v-if="getName(users[2]) !== ''"
            :title="getUserName(users[2])"
            class="sr-mention"
            v-html="getName(users[2])"
          ></a>
          <a
            v-if="getName(users[2]) === '' && getUserName(users[2]) !== ''"
            class="sr-mention"
            v-text="'@' + getUserName(users[2])"
          ></a>
          <a
            v-if="getName(users[2]) === '' && getUserName(users[2]) === ''"
            class="sr-mention"
            v-text="'@' + getOrigin(users[2])"
          ></a>
        </span>
      </div>
      <div class="third-content" style="text-align: center">
        <br />
        <span class="font-weight-medium">
          {{ $t("dashboard.ranking.created") }} {{ users[2].created_at | moment("from", true) }}
        </span>
        <br />
        <span class="font-weight-medium">
          {{ users[2].publication_counter }} {{ $t("dashboard.ranking.publications") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Podium",
  props: {
    users: { type: Array, required: true },
  },
  mounted() {},
  methods: {
    // Show the selected user
    show(id) {
      this.$emit("show", id)
    },
    getUserName(user) {
      const semicolonPos = user.user_name.indexOf(":")
      if (semicolonPos > 0) {
        return ""
      } else {
        return `${user.user_name}`
      }
    },
    getName(user) {
      let name = ""
      if (user.first_name) name = name + " " + user.first_name
      if (user.last_name) name = name + " " + user.last_name
      return name.trim()
    },
    displayOrigin(user) {
      return this.$t("origin.source") + this.getOrigin(user)
    },
    getOrigin(user) {
      const securating = "Securating"
      const semicolonPos = user.user_name.indexOf(":")
      if (semicolonPos > 0) {
        const prefix = user.user_name.substr(0, semicolonPos)

        switch (prefix) {
          case "anonymous":
            return securating
          default:
            return `${this.$t("origin." + prefix)}`
        }
      } else {
        return securating
      }
    },
  },
}
</script>
